/** Panel planning map motion / click timing (shared) */

/** view.fit / fly animation — 0이면 즉시 이동 */
export const PANEL_MAP_PAN_DURATION_MS = 120;

/** singleclick 처리 지연 (dblclick과 구분) */
export const PANEL_MAP_SINGLE_CLICK_DELAY_MS = 150;

/** dblclick 직후 singleclick 무시 시간 */
export const PANEL_MAP_DBLCLICK_GUARD_MS = 280;

/** 사이트 위치 fly 애니메이션 */
export const PANEL_MAP_FLY_DURATION_MS = 120;

/** API 직후 getSiteDesign 재조회 전 짧은 대기 (서버 반영) */
export const PANEL_MAP_SITE_DESIGN_REFETCH_DELAY_MS = 50;

/** 트리 Array/String 선택 view.fit — maxZoom (이보다 가까이 가지 않음) */
export const PANEL_MAP_FIT_MAX_ZOOM = 20;

export const PANEL_MAP_FIT_PADDING = [50, 50, 50, 50];

/** 대시보드 Array 이동 시 이보다 축소하지 않음 (패널 플래닝 작업 줌과 동일) */
export const PANEL_MAP_FIT_MIN_ZOOM = PANEL_MAP_FIT_MAX_ZOOM;

/** 트리 Module 선택 — 현재 줌에서 이만큼만 당김 */
export const PANEL_MAP_MODULE_ZOOM_DELTA = 1;

/** 트리 Module 선택 — 이보다 가까이 가지 않음 */
export const PANEL_MAP_MODULE_MAX_ZOOM = 22;

/**
 * 트리 선택 시 카메라
 * - array: 영역 fit
 * - string: 카메라 유지
 * - module: 중심으로 이동 + 살짝 확대
 * @param {string} type
 * @returns {'fit'|'nudge'|'none'}
 */
export function resolvePanelTreeSelectionCamera(type) {
  if (type === 'array') return 'fit';
  if (type === 'module') return 'nudge';
  return 'none';
}

export function resolveModuleNudgeZoom(
  currentZoom,
  delta = PANEL_MAP_MODULE_ZOOM_DELTA,
  maxZoom = PANEL_MAP_MODULE_MAX_ZOOM
) {
  return Math.min((Number(currentZoom) || 0) + delta, maxZoom);
}
